import { Component, Vue, Watch } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { UserModule } from '@/store/modules/user'
import { menuBtn } from '@/utils/menu_level2_button'
import { setProjectDissertation, getProjectDissertationInfo, setProjectDissertationById } from '@/api/dissertation'
import MoreUsersFilter from "@/components/moreUsersFilter/index.vue";
import * as math from "mathjs";

@Component({
    components:{
        MoreUsersFilter
    }
})
export default class AllProjectInfo extends Vue {
    newly_build_show = true
    name = ''
    price = ''
    codes = ''
    costList = [{ name: '', price: '' }]
    projectId: number = undefined
    infoData = null

    visualRange = ''
    visualUserList: string[] = []
    logShow = true
    logList = []
    formModel = {
        name: '',
        price: '',
        directorUserId: '',
        directorUserName: ''
    }
    rules = {
        name: [{required: true, message: '请填写论文项目名称', trigger: 'blur'}],
        price: [{required: true, message: '请填写项目定价', trigger: 'blur'}],
        directorUserId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
    }
    editUserName= ''
    loading = false

    get userId() {
        return UserModule.userId
    }

    get userName(){
        return UserModule.userName
    }

    get allCostNum() {
        let num = 0
        this.costList.forEach(item =>
            num = math.number(math.add(math.bignumber(num), math.bignumber(item.price ? Number(item.price) : 0)))
        )
        return num
    }

    created() {
        // 编辑跳转url的type == 1
        if(this.$route.query.type === '1') {
            this.newly_build_show = false
            this.getData()
        }
        this.projectId = Number(this.$route.query.id)
    }

    formatDate = formatDate
    buttonShow = menuBtn

    // 表单校验
    submitForm (refName: string) {
        return new Promise<void>((resolve, reject) => {
            (this.$refs as any)[refName].validate((valid: any) => {
                if (valid) {
                resolve();
                } else {
                // 注意此处需要传入一个new Error(''),否则会报错Expected the Promise rejection reason to be an Error
                reject(new Error('错误'));
                }
            });
        });
    }

    clickSubmit() {
        Promise.all([this.submitForm('project_information_form'), this.submitForm('responsible_person_form')]).then(() => {
            this.costList.forEach((item, index) => {
                if(!item.name && !item.price){
                    this.costList.splice(index, 1)
                }
            })
            const bol = this.costList.every(item => (item.name && item.price))
            if(!bol) {
                this.$message.error('请将项目成本明细填写')
                return
            }
            // if(typeof this.name != 'string') {
            //     this.$message.error('论文项目请输入中文')
            //     return
            // }
            const price = this.formModel.price;
            const names = this.formModel.name;
            const param = {
                name: names.toString(),
                price: price.toString(),
                userId: this.formModel.directorUserId,
                projectDissertationCostList: this.costList
            }
            this.loading =  true
            setProjectDissertation(param)
            this.$message.success('新增成功')
            this.loading=  false
            setTimeout(() => {
                window.close()
            }, 1500)
          }).catch(() => {
            this.loading=  false
            // this.$message.error('请填写完整')
            // this.$tipMessage('error', '请填写完整');
          })
    }
    clickEdit() {
        Promise.all([this.submitForm('project_information_form'), this.submitForm('responsible_person_form')]).then(() => {
            if(this.buttonShow(91)){  //项目成本明细
                this.costList.forEach((item, index) => {
                    if(!item.name && !item.price){
                        this.costList.splice(index, 1)
                    }
                })
                const bol = this.costList.every(item => (item.name && item.price))
                if(!bol) {
                    this.$message.error('请将项目成本明细填写')
                    return
                }
            }
            const price = this.formModel.price;
            const names = this.formModel.name;
            const param = {
                id: this.projectId,
                name: names.toString(),
                price: price.toString(),
                userId: this.formModel.directorUserId,
                projectDissertationCostList: this.costList,
            }
            if(!this.buttonShow(91)){
                delete param.projectDissertationCostList
            }
            this.loading=  true
            setProjectDissertationById(param)
            this.$message.success('修改成功')
            this.loading=  false
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch(() => {
            this.loading=  false
            // this.$message.error('请填写完整')
            // this.$tipMessage('error', '请填写完整');
        })

    }

    async getData() {
        const ids = Number(this.$route.query.id)
        const data: any = await getProjectDissertationInfo(ids)
        this.infoData = data.projectDissertation
        this.formModel.name = data.projectDissertation.name
        this.formModel.price = data.projectDissertation.price
        this.codes = data.projectDissertation.code
        this.costList = data.projectDissertation.projectDissertationCostList
        this.formModel.directorUserId = data.projectDissertation.userId
        this.formModel.directorUserName = data.projectDissertation.userRealName
    }

    addCostItem() {
        this.costList.push({ name: '', price: '' })
    }
    delCostItem(index){
        this.costList.splice(index,1)
    }

    changInput(val, index) {
        val = this.handleBackMoneyOnInput(val, '2')
        this.costList[index].price = val
    }
    handleBackMoneyOnInput(num,limit){
        const len1 = num.charAt(0)
        // 转化为数字形式--包含小数，负数
        // 先把非数字的都替换掉，除了数字和.
        num = num.replace(/[^\d.]/g, '')
        // 必须保证第一个为数字而不是.
        num = num.replace(/^\./g, '')
        // 保证只有出现一个.而没有多个.
        num = num.replace(/\.{2,}/g, '.')
        // 保证.只出现一次，而不能出现两次以上
        num = num.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        // 如果第一位是负号，则允许添加
        if (len1 === '-') {
            num = '-' + num
        }
        return num
    }

    changeDirectorUserId(e) {
        this.formModel.directorUserId = e.id
    }


    @Watch('userId')
    handleUserIdChange(userId: string) {
        if(!this.formModel.directorUserId){
            this.formModel.directorUserId = userId
        }
    }
    @Watch('userName')
    handleUserNameChange(userName: string) {
        if(!this.formModel.directorUserName){
            this.formModel.directorUserName = userName
        }
    }
}
